import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaRegThumbsUp,
  FaLinkedin,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaYoutube,
  FaGithub,
  FaSpotify,
  FaFilm,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

/*
  One "socials" icon. Hovering (desktop) or tapping (phone) opens a small
  row of links underneath it. Edit the list below to add, remove, reorder,
  or change links; the menu builds itself from it.

  Entries with `url` open an outside site in a new tab.
  Entries with `to` are pages on this site (handled by React Router).
*/
const SOCIALS = [
  { name: 'LinkedIn',  url: 'https://www.linkedin.com/in/flyboyblake/',  Icon: FaLinkedin },
  { name: 'Instagram', url: 'https://www.instagram.com/flyboyblake/',    Icon: FaInstagram },
  { name: 'Facebook',  url: 'https://www.facebook.com/FlyBoyBlake',      Icon: FaFacebook },
  { name: 'TikTok',    url: 'https://www.tiktok.com/@flyboyblake',       Icon: FaTiktok },
  { name: 'YouTube',   url: 'https://www.youtube.com/@flyboyblakeo',     Icon: FaYoutube },
  { name: 'X',         url: 'https://x.com/flyboyblakeo',                 Icon: FaXTwitter },
  { name: 'GitHub',    url: 'https://github.com/Blake14Christ',           Icon: FaGithub },
  { name: 'Discography', to: '/discography',                             Icon: FaSpotify },
  { name: 'Films',       to: '/films',                                   Icon: FaFilm },
];

class Socials extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.wrapRef = React.createRef();
    this.closeTimer = null;
    this.pointerType = null;  // 'mouse' | 'touch' | 'pen' for the current press
    this.wasOpen = false;     // menu state at the moment the press started

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.closeSoon = this.closeSoon.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.handleOutside = this.handleOutside.bind(this);
    this.handleKey = this.handleKey.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutside);
    document.addEventListener('touchstart', this.handleOutside);
    document.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    clearTimeout(this.closeTimer);
    document.removeEventListener('mousedown', this.handleOutside);
    document.removeEventListener('touchstart', this.handleOutside);
    document.removeEventListener('keydown', this.handleKey);
  }

  open() {
    clearTimeout(this.closeTimer);
    this.setState({ open: true });
  }

  close() {
    clearTimeout(this.closeTimer);
    this.setState({ open: false });
  }

  // small delay so the menu doesn't vanish while the mouse moves onto it
  closeSoon() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(this.close, 250);
  }

  // Phones fire hover and focus events on a tap before the click arrives,
  // which would open the menu and then instantly close it again. So a click
  // decides based on how it was pressed:
  //   mouse    – hover already handles it; keep it open
  //   touch    – flip whatever state the menu was in before the tap
  //   keyboard – flip the current state
  onPointerDown(e) {
    this.pointerType = e.pointerType;
    this.wasOpen = this.state.open;
  }

  toggle(e) {
    e.preventDefault();
    const type = this.pointerType;
    this.pointerType = null;

    if (type === 'mouse') return this.open();
    const wasOpen = type ? this.wasOpen : this.state.open;
    wasOpen ? this.close() : this.open();
  }

  handleOutside(e) {
    if (this.wrapRef.current && !this.wrapRef.current.contains(e.target)) {
      this.close();
    }
  }

  handleKey(e) {
    if (e.key === 'Escape') this.close();
  }

  render() {
    const { primary, secondary, onNavigate } = this.props;
    const { open } = this.state;

    return (
      <span
        ref={this.wrapRef}
        className={'socials' + (open ? ' socials--open' : '')}
        onPointerEnter={(e) => { if (e.pointerType === 'mouse') this.open(); }}
        onPointerLeave={(e) => { if (e.pointerType === 'mouse') this.closeSoon(); }}
        onFocus={this.open}
        onBlur={(e) => {
          if (!e.currentTarget.contains(e.relatedTarget)) this.closeSoon();
        }}
      >
        <button
          type="button"
          className="fa-link socials-toggle"
          style={{ color: primary }}
          onPointerDown={this.onPointerDown}
          onClick={this.toggle}
          aria-label="Socials and more"
          aria-expanded={open}
          title="Socials"
        >
          <FaRegThumbsUp />
        </button>

        <span
          className="socials-menu"
          style={{ backgroundColor: secondary, borderColor: primary }}
          role="menu"
        >
          {SOCIALS.map(({ name, url, to, Icon }) => {
            const shared = {
              className: 'socials-item',
              style: { color: primary },
              title: name,
              'aria-label': name,
              role: 'menuitem',
              tabIndex: open ? 0 : -1,
            };
            return to ? (
              <Link
                key={name}
                {...shared}
                to={to}
                onClick={() => {
                  this.close();
                  if (onNavigate) onNavigate();
                }}
              >
                <Icon />
              </Link>
            ) : (
              <a key={name} {...shared} href={url} target="_blank" rel="noopener noreferrer">
                <Icon />
              </a>
            );
          })}
        </span>
      </span>
    );
  }
}

export default Socials;
